import Component from '@glimmer/component';
import { service } from '@ember/service';
import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import {
  HdsBadge,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { boxPadding } from 'core/modifiers';
import consulHasTfQuickstartPermissions from 'core/helpers/consul-has-tf-quickstart-permissions';
import {
  getTerraformQuickstartClickedPayload,
  TerraformQuickstartLaunchPoint,
} from 'core/utils/consul-analytics';
import { CONSUL_TERRAFORM_QUICKSTART_CLICKED } from 'core/utils/consts/analytics-events/consul';

export default class PageProjectsDashboardServiceCardConsulTfQuickstart extends Component {
  @service analytics;

  sendTfQuickstartAnalyticsEvent = () => {
    this.analytics.trackEvent(
      CONSUL_TERRAFORM_QUICKSTART_CLICKED,
      getTerraformQuickstartClickedPayload(
        TerraformQuickstartLaunchPoint.Overview
      )
    );
  };

  <template>
    {{#if (consulHasTfQuickstartPermissions)}}
      <div {{boxPadding "md 0 0 0"}}>
        <div {{boxPadding "xs 0"}}>
          <HdsBadge
            @text={{t "service-card.consul-tf-quickstart"}}
            data-test-service-card-release-badge
          />
        </div>
        <p
          class="hds-typography-body-200 body-text-color projectsDashboard__spacer-8"
          data-test-page-overview-consul-tf-quickstart-description
        >
          {{t "service-card.consul-tf-quickstart-description"}}
        </p>
        <HdsLinkStandalone
          @route="consul.terraform-quickstart"
          @icon="zap"
          @query={{hash project_id=@projectId}}
          @text={{t "service-card.consul-tf-link"}}
          data-test-page-overview-consul-tf-quickstart-cta
          {{on "click" this.sendTfQuickstartAnalyticsEvent}}
        />
      </div>
    {{/if}}
  </template>
}
